import React from "react";
import { ReactNode } from "react";
import ObservableState from "../utils/ObservableState";
import * as ui from "../native";
import ObservableComponent from "./ObservableComponent";
import BaseUIProps, { copyBaseUIProps } from "../native/ui/BaseUIProps";
import TextView from "./TextView";
import DateTime from "../core/DateTime";
import IconView from "./IconView";
import DateFormat from "../classes/DateFormat";

export interface DateTimeFormatViewProps extends BaseUIProps {
  key?: string;
  value: DateTime;
  dateFormat: string;
  timeFormat: string;
  icon: ui.IconData;
}

class _DateTimeFormatViewState extends ObservableComponent<DateTimeFormatViewProps> {
  static defaultProps = {
    value: null,
    dateFormat: "",
    timeFormat: "",
    icon: null,
  };
  formatDate: string = "";
  formatTime: string = "";
  public constructor(props: DateTimeFormatViewProps) {
    super(props);

    this.initState();
  }
  public get value(): DateTime {
    return this.props.value;
  }
  public get dateFormat(): string {
    return this.props.dateFormat;
  }
  public get timeFormat(): string {
    return this.props.timeFormat;
  }
  public get icon(): ui.IconData {
    return this.props.icon;
  }
  public initState() {
    super.initState();

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {
    this.on(["dateFormat", "value"], this.computeFormatDate);

    this.computeFormatDate();

    this.on(["timeFormat", "value"], this.computeFormatTime);

    this.computeFormatTime();

    this.on(["formatDate", "formatTime", "icon"], this.rebuild);
  }
  public componentDidUpdate(prevProps: DateTimeFormatViewProps): void {
    super.componentDidUpdate(prevProps);

    if (prevProps.value !== this.props.value) {
      this.fire("value", this);
    }

    if (prevProps.dateFormat !== this.props.dateFormat) {
      this.fire("dateFormat", this);
    }

    if (prevProps.timeFormat !== this.props.timeFormat) {
      this.fire("timeFormat", this);
    }

    if (prevProps.icon !== this.props.icon) {
      this.fire("icon", this);
    }
  }
  public setFormatDate(val: string): void {
    let isValChanged: boolean = this.formatDate !== val;

    if (!isValChanged) {
      return;
    }

    this.formatDate = val;

    this.fire("formatDate", this);
  }
  public computeFormatDate = (): void => {
    try {
      this.setFormatDate(
        this.value === null
          ? ""
          : new DateFormat(
              this.dateFormat === null ? "" : this.dateFormat
            ).format(this.value)
      );
    } catch (exception) {
      console.log(" exception in computeFormatDate : " + exception.toString());

      this.setFormatDate("");
    }
  };
  public setFormatTime(val: string): void {
    let isValChanged: boolean = this.formatTime !== val;

    if (!isValChanged) {
      return;
    }

    this.formatTime = val;

    this.fire("formatTime", this);
  }
  public computeFormatTime = (): void => {
    try {
      this.setFormatTime(
        this.value === null
          ? ""
          : new DateFormat(
              this.timeFormat === null ? "" : this.timeFormat
            ).format(this.value)
      );
    } catch (exception) {
      console.log(" exception in computeFormatTime : " + exception.toString());

      this.setFormatTime("");
    }
  };
  public render(): ReactNode {
    return ui.Column({
      mainAxisAlignment: ui.MainAxisAlignment.start,
      crossAxisAlignment: ui.CrossAxisAlignment.start,
      children: [
        TextView({
          data: this.formatDate,
          style: new ui.TextStyle({ fontSize: 17 }),
          className: "x2bb hc",
          key: "0",
        }),
        ui.Row({
          children: [
            IconView({
              icon: this.icon,
              size: 16,
              className: "xa53",
              key: "0",
            }),
            TextView({
              data: this.formatTime,
              style: new ui.TextStyle({ fontSize: 16 }),
              className: "x455b",
              key: "1",
            }),
          ],
          className: "xc43 hc h",
          key: "1",
        }),
      ],
      className: ui.join(this.props.className, "DateTimeFormatView x9ad hc h"),
      ...copyBaseUIProps(this.props),
    });
  }
}
export default function DateTimeFormatView(props: DateTimeFormatViewProps) {
  return React.createElement(_DateTimeFormatViewState, {
    ..._DateTimeFormatViewState.defaultProps,
    ...props,
  });
}
